<template>
  <div>
    <div class="modal-card has-text-left" style="width: fit-content">
      <header v-if="!isProfile" class="modal-card-head">
        <p class="modal-card-title">
          {{ $t("ShareModal.TITLE_SEQUENCE") }}
        </p>
        <button type="button" class="delete" @click="close()"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <div>
            <!-- @input caught the radio's native bubbled "input" event, which fires
            before v-model actually commits (Buefy 3 only emits update:modelValue) -
            the handler read this.sharedType one click behind. @update:model-value
            fires only once v-model has committed. -->
            <b-field label="Partage : " class="mb-4">
              <b-radio
                v-model="sharedType"
                :native-value="0"
                @update:model-value="dbUpdateSequenceShared()"
                type="is-outlined"
              >
                <span>Désactivé</span>
              </b-radio>
              <b-radio
                v-if="isCurrentUserInstitutionTeacher"
                v-model="sharedType"
                :native-value="2"
                @update:model-value="dbUpdateSequenceShared()"
                type="is-outlined"
              >
                <span>Classes et groupes</span>
              </b-radio>

              <b-radio
                v-model="sharedType"
                :native-value="1"
                @update:model-value="dbUpdateSequenceShared()"
                type="is-outlined"
              >
                Via un lien
              </b-radio>
            </b-field>
          </div>
          <hr v-if="sharedType != 0" />

          <b-tabs v-if="sharedType == 2">
            <b-tab-item
              v-if="isCurrentUserInstitutionTeacher"
              label="Mes classes"
            >
              <h1 class="title is-4">
                Mes classes
                <b-tooltip
                  append-to-body
                  position="is-bottom"
                  multilined
                  label="Si la classe que vous cherchez n'est pas dans 'Mes classes', recherchez dans 'Autres classes de l'établissement'."
                >
                  <b-icon size="is-small" icon="question-circle"></b-icon>
                </b-tooltip>
              </h1>
              <template v-if="teacherDivs.length > 0">
                <b-table :key="tableKeyDivs" :data="teacherDivs">
                  <b-table-column field="divs" label="Classe">
                    <template v-slot="props">
                      {{ convertStringFormat(props.row.div) }}
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="shared"
                    :label="$t('ActivityList.SHARED')"
                    sortable
                    centered
                    v-slot="props"
                  >
                    <b-field>
                      <b-switch
                        v-model="props.row.shared"
                        type="is-info"
                        @update:model-value="dbUpdateSequenceSharedWithDiv(props.row)"
                      >
                      </b-switch>
                    </b-field>
                  </b-table-column>
                </b-table>

                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.SHARE_WITH_STUDENTS_DIV") }}
                </b-message>
              </template>
              <template v-else>
                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.NO_DIV") }}
                </b-message>
              </template>
            </b-tab-item>
            <b-tab-item
              v-if="isCurrentUserInstitutionTeacher"
              label="Mes Groupes"
            >
              <h1 class="title is-4">
                Mes Groupes
                <b-tooltip
                  append-to-body
                  position="is-bottom"
                  multilined
                  label="Si le groupe que vous cherchez n'est pas dans 'Mes groupes', recherchez dans 'Autres groupes de l'établissement'."
                >
                  <b-icon size="is-small" icon="question-circle"></b-icon>
                </b-tooltip>
              </h1>
              <template v-if="teacherGros.length > 0">
                <b-table :key="tableKeyGros" :data="teacherGros">
                  <b-table-column field="gros" label="Groupe">
                    <template v-slot="props">
                      {{ convertStringFormat(props.row.gro) }}
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="shared"
                    :label="$t('ActivityList.SHARED')"
                    sortable
                    centered
                    v-slot="props"
                  >
                    <b-field>
                      <b-switch
                        v-model="props.row.shared"
                        type="is-info"
                        @update:model-value="dbUpdateSequenceSharedWithGro(props.row)"
                      >
                      </b-switch>
                    </b-field>
                  </b-table-column>
                </b-table>

                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.SHARE_WITH_STUDENTS_GRO") }}
                </b-message>
              </template>
              <template v-else>
                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.NO_GRO") }}
                </b-message>
              </template>
            </b-tab-item>

            <b-tab-item
              v-if="isCurrentUserInstitutionTeacher"
              label="Autres classes de l'établissement"
            >
              <h1 class="title is-4">
                Autres classes
                <b-tooltip
                  append-to-body
                  position="is-bottom"
                  multilined
                  label="Si la classe que vous cherchez n'est ni dans 'Mes classes' ni dans 'Autres classes de l'établissement', contactez votre administrateur."
                >
                  <b-icon size="is-small" icon="question-circle"></b-icon>
                </b-tooltip>
              </h1>
              <template v-if="UAIDivs.length > 0">
                <b-table :key="tableKeyUAIDivs" :data="UAIDivs">
                  <b-table-column field="divs" label="Classe">
                    <template v-slot="props">
                      {{ convertStringFormat(props.row.div) }}</template
                    >
                  </b-table-column>

                  <b-table-column
                    field="shared"
                    :label="$t('ActivityList.SHARED')"
                    sortable
                    centered
                    v-slot="props"
                  >
                    <b-field>
                      <b-switch
                        v-model="props.row.shared"
                        type="is-info"
                        @update:model-value="dbUpdateSequenceSharedWithDiv(props.row)"
                      >
                      </b-switch>
                    </b-field>
                  </b-table-column>
                </b-table>
                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.SHARE_WITH_STUDENTS_DIV") }}
                </b-message>
              </template>
              <template v-if="UAIDivs.length == 0">
                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.NO_DIV") }}
                </b-message>
              </template>
            </b-tab-item>
            <b-tab-item
              v-if="isCurrentUserInstitutionTeacher"
              label="Autres groupes de l'établissement"
            >
              <template>
                <h1 class="title is-4">
                  Autres groupes
                  <b-tooltip
                    append-to-body
                    position="is-bottom"
                    multilined
                    label="Si le groupe que vous cherchez n'est ni dans 'Mes groupes' ni dans 'Autres groupes de l'établissement', contactez votre administrateur."
                  >
                    <b-icon size="is-small" icon="question-circle"></b-icon>
                  </b-tooltip>
                </h1>
                <template v-if="UAIGros.length > 0">
                  <b-table :key="tableKeyUAIGros" :data="UAIGros">
                    <b-table-column field="gros" label="Groupe">
                      <template v-slot="props">
                        {{ convertStringFormat(props.row.div) }}</template
                      >
                    </b-table-column>

                    <b-table-column
                      field="shared"
                      :label="$t('ActivityList.SHARED')"
                      sortable
                      centered
                      v-slot="props"
                    >
                      <b-field>
                        <b-switch
                          v-model="props.row.shared"
                          type="is-info"
                          @update:model-value="dbUpdateSequenceSharedWithGro(props.row)"
                        >
                        </b-switch>
                      </b-field>
                    </b-table-column>
                  </b-table>
                  <b-message class="mt-3" type="is-info">
                    {{ $t("ShareModal.SHARE_WITH_STUDENTS_GRO") }}
                  </b-message></template
                >
              </template>
              <template v-if="UAIGros.length == 0">
                <b-message class="mt-3" type="is-info">
                  {{ $t("ShareModal.NO_GRO") }}
                </b-message>
              </template>
            </b-tab-item>
          </b-tabs>
          <div v-if="sharedType == 1" class="mb-4">
            <h1 class="title is-4">
              {{ $t("ShareModal.QRCODE") }}
            </h1>
            <div class="columns is-vcentered is-centered">
              <div class="column is-narrow">
                <qrcode-vue
                  :value="getSharedURL"
                  :size="QRCodeSmallSize"
                  level="H"
                />
              </div>
              <div class="column ml-2 is-narrow">
                <b-button
                  type="is-info is-light"
                  style="vertical-align: middle"
                  icon-left="search-plus"
                  @click="showModalQRCode()"
                >
                </b-button>
              </div>
            </div>
            <h1 class="title is-4">
              {{ $t("ShareModal.WEBLINK") }}
            </h1>
            <div class="columns is-vcentered is-multiline my-0 ml-4">
              <div class="column is-narrow">
                <span> {{ this.getSharedURL }}</span>
              </div>
              <div class="column ml-2 is-narrow">
                <b-button
                  type="is-info is-light"
                  pack="fas"
                  icon-left="copy"
                  @click="updateClipboard(getSharedURL)"
                  >{{ $t("ShareModal.LINKMESSAGE") }}</b-button
                >
              </div>
            </div>
            <div class="mb-4 ml-4">
              <!-- @input caught the checkbox's native bubbled "input" event, firing
              before v-model committed keyEnabled - see the comment on the radios above. -->
              <b-switch
                v-model="keyEnabled"
                @update:model-value="
                  keyEnabled && sequenceKey == ''
                    ? openDialogChangeKey()
                    : dbUpdateSequenceShared()
                "
              >
                Protéger par une clé d'accés
              </b-switch>

              <b-field
                v-if="keyEnabled"
                label-position="inside"
                :label="$t('SequenceEdit.KEY')"
              >
                <b-input
                  type="text"
                  name="key"
                  :value="sequenceKey"
                  required
                  disabled
                  maxlength="10"
                >
                </b-input>
                <p class="control">
                  <b-button
                    type="is-text"
                    @click="openDialogChangeKey()"
                    icon-left="edit"
                  ></b-button>
                </p>
              </b-field>
            </div>
            <b-collapse :model-value="false" class="mb-5" aria-id="contentIdForA11y1">
              <template #trigger="props">
                <b-icon
                  :icon="props.open ? 'caret-down' : 'caret-right'"
                  style="vertical-align: middle"
                >
                </b-icon>
                <span
                  style="vertical-align: middle"
                  class="title is-5 mb-2"
                  aria-controls="contentIdForA11y1"
                  :aria-expanded="props.open"
                >
                  {{ $t("Use.ADVANCED_SHARE_SETTINGS") }}
                </span>
              </template>
              <div>
                <OfflineDownload
                  :sequenceId="this.$props.id"
                  :sequenceName="this.$props.name"
                />
              </div>
            </b-collapse>
          </div>
        </div>
      </section>
      <footer
        v-if="!isProfile"
        class="modal-card-foot is-justify-content-space-between"
      ></footer>
    </div>

    <b-modal v-model="isModalQRCodeActive" :can-cancel="['outside', 'escape']">
      <header class="modal-card-head">
        <p class="modal-card-title">QRCode</p>
        <button type="button" class="delete" @click="hideModalQRCode()" />
      </header>
      <section class="modal-card-body is-vcentered">
        <qrcode-vue
          :value="getSharedURL"
          :size="QRCodeBigSize"
          level="H"
          class="has-text-centered"
        />
      </section>
    </b-modal>
  </div>
</template>

<script>
import { frontendURL } from "../config/settings-network.mjs";

import b64ToBlob from "b64-to-blob";
import fileSaver from "file-saver";

import SequenceDataService from "../services/SequenceDataService";
import GarDivDataService from "../services/GarDivDataService";
import GarGroDataService from "../services/GarGroDataService";

import UserDataService from "../services/UserDataService";
import QrcodeVue from "qrcode.vue";

import OfflineDownload from "./OfflineDownload.vue";

import UtilsMixin from "../mixins/UtilsMixin.js";

export default {
  name: "ShareActivityModal",
  mixins: [UtilsMixin],

  components: {
    QrcodeVue,
    OfflineDownload,
  },
  data() {
    return {
      url: frontendURL,
      repetitions: 100, //100 by default (means infinite)
      customMaxAttempts: 1, //By default keep setting from blockly activity,
      // If we want to change this setting via UI uncomment the related b-field

      isLoading: false,
      isFullPage: true,
      sharedType: 0,
      keyEnabled: false,
      sequenceKey: "",
      tableKeyGros: 0, // Valeur initiale de la clé du tableau
      tableKeyUAIGros: 0, // Valeur initiale de la clé du tableau
      tableKeyDivs: 0, // Valeur initiale de la clé du tableau
      tableKeyUAIDivs: 0, // Valeur initiale de la clé du tableau
      isModalQRCodeActive: false,
      QRCodeSmallSize: 150,
      QRCodeBigSize: 500,
      isKeyEditable: false,
      teams: [],
      gros: [],
      divs: [],
      userUAI: "",
      teacherGros: [],
      teacherDivs: [],
      UAIGros: [],
      UAIDivs: [],
      currentUAI: "",
    };
  },
  props: {
    id: {
      type: Number,
      default: -1,
    },
    name: {
      type: String,
      default: "",
    },
    shared: {
      //only for activity type
      type: Number,
      default: 0,
    },
    hasNestedQuestion: {
      //only for activity type
      type: Boolean,
      default: false,
    },
    maxAttempts: {
      //only for activity type
      type: Number,
      default: 1,
    },
    readOnly: {
      //only for activity type
      type: Boolean,
      default: true,
    },

    isProfile: {
      type: Boolean,
      default: false,
    },
    currentKeyEnabled: {
      type: Boolean,
      default: false,
    },
    currentKey: {
      type: String,
      default: "",
    },
  },
  watch: {
    shared: function (shared) {
      this.sharedType = shared;
    },
    currentKeyEnabled: function (keyEnabled) {
      this.keyEnabled = keyEnabled;
    },
    currentKey: function (sequenceKey) {
      this.sequenceKey = sequenceKey;
    },
  },
  computed: {
    getSharedURL() {
      return this.url + "/sequence/" + this.$props.id;
    },
  },
  mounted() {
    console.log("Mounted this.$props.shared:", this.$props.shared);
    this.sharedType = this.$props.shared;
    this.keyEnabled = this.$props.currentKeyEnabled;
    this.sequenceKey = this.$props.currentKey;
    if (this.isCurrentUserInstitutionTeacher) {
      this.dbGetGarDivs(this.currentUser.id);
      this.dbGetGarGros(this.currentUser.id);
    }
  },
  methods: {
    handleInputClick(id) {
      console.log("handleInputClick", id);
    },
    hideModalQRCode() {
      this.isModalQRCodeActive = false;
    },

    showModalQRCode() {
      this.isModalQRCodeActive = true;
    },

    /** downloadSequenceOffline in ZIP (all package with libs), HTML (), SCORM
     *
     */
    downloadSequenceOffline(id, name, isScorm, isHTMLOnly) {
      //On lance un loading screen le temps du traitement
      this.isFullPage = true;
      this.isLoading = true;

      //On envoie dans la requête les paramètres de la séquence pour qu'ils soit pris en compte dans notre fichier zip
      SequenceDataService.zipSequenceOffline(
        id,
        null,
        null,
        null,
        null,
        null,
        false,
        isScorm,
        isHTMLOnly
      ).then((response) => {
        //On convertie le fichier en base64, en fichier zip
        const blob = b64ToBlob(response.data, "application/zip");

        //On enregistre le fichier sur la machine local grace à fileSaver
        //On donne le nom de l'activité (filename) au fichier zip
        fileSaver.saveAs(blob, name.replace(/['"]+/g, "") + ".zip");

        //On stop le loading screen
        this.isLoading = false;
        this.isFullPage = false;
      });
    },

    close() {
      this.$emit("closeShareSequenceModal");
    },

    changeKey() {
      if (this.sequenceKey == "") {
        this.keyEnabled = false;
      }
      this.dbUpdateSequenceShared();
      this.isKeyEditable = false;
    },
    cancelChangeKey() {
      this.sequenceKey = this.$props.currentKey;
      if (this.sequenceKey == "") {
        this.keyEnabled = false;
      }
      this.isKeyEditable = false;
    },

    openDialogChangeKey() {
      this.$buefy.dialog.prompt({
        message: this.$t("SequenceList.KEY_MESSAGE"),
        inputAttrs: {
          type: "text",
          placeholder: "",
          value: this.sequenceKey,
        },
        confirmText: this.$t("MenuEleda4Teachers.SET_NAME_BTN"),
        cancelText: this.$t("MenuEleda4Teachers.BTN_CANCEL"),
        trapFocus: true,
        onConfirm: (value) => {
          if (value == "") {
            this.keyEnabled = false;
          } else {
            this.sequenceKey = value;
          }
          this.dbUpdateSequenceShared();
        },
        onCancel: () => {
          if (this.sequenceKey == "") {
            this.keyEnabled = false;
          }
          this.$emit(
            "updateSequenceShared",
            this.$props.id,
            this.sharedType,
            this.keyEnabled,
            this.sequenceKey
          );
        },
      });
    },

    dbUpdateSequenceShared() {
      console.log("dbUpdateSequenceShared", this.sharedType, this.sequenceKey);
      let values = {
        shared: this.sharedType,
        keyEnabled: this.keyEnabled,
        key: this.sequenceKey,
      };
      SequenceDataService.update(this.$props.id, values)
        .then(() => {
          this.$emit(
            "updateSequenceShared",
            this.$props.id,
            this.sharedType,
            this.keyEnabled,
            this.sequenceKey
          );
          this.showToast(this.$t("Toast.INFO_UPDATED"), "is-success");
        })
        .catch((e) => {
          console.log(e);
          this.showToast(
            "Error when updating sequence sharing preferences",
            "is-danger"
          );
        });
    },

    dbGetGarDivs(id) {
      UserDataService.getUserGarDivs(id)
        .then((response) => {
          this.teacherDivs = response.data.divs;

          this.userUAI = response.data.uai;
          GarDivDataService.getDivsByUai(this.userUAI).then((response) => {
            var UAIAllDivs = response.data;
            //newUAIDivs sont les divs de l'UAI qui ne sont pas les divs personnels de l'enseignant
            this.UAIAllDivs = UAIAllDivs.filter(
              (uaiDiv) => !this.teacherDivs.some((div) => div.id === uaiDiv.id)
            );
            this.checkIfGarDivsShared(this.teacherDivs);
            this.tableKeyDivs += 1; // Incrémentez la clé pour forcer le ré-rendu du tableau
            this.checkIfGarDivsShared(this.UAIDivs);
            this.tableKeyUAIDivs += 1; // Incrémentez la clé pour forcer le ré-rendu du tableau
          });
        })
        .catch((e) => {
          console.log(e);
          this.showToast("Error when retrieving user's GAR divs", "is-danger");
        });
    },

    dbGetGarGros(id) {
      UserDataService.getUserGarGros(id)
        .then((response) => {
          this.teacherGros = response.data.gros;

          this.userUAI = response.data.uai;
          GarGroDataService.getGrosByUai(this.userUAI).then((response) => {
            var UAIAllGros = response.data;
            //newUAIDivs sont les divs de l'UAI qui ne sont pas les divs personnels de l'enseignant
            this.UAIAllGros = UAIAllGros.filter(
              (uaiGro) => !this.teacherGros.some((div) => div.id === uaiGro.id)
            );
            this.checkIfGarGrosShared(this.teacherGros);
            this.tableKeyGros += 1; // Incrémentez la clé pour forcer le ré-rendu du tableau
            this.checkIfGarGrosShared(this.UAIGros);
            this.tableKeyUAIGros += 1; // Incrémentez la clé pour forcer le ré-rendu du tableau
          });
        })
        .catch((e) => {
          console.log(e);
          this.showToast("Error when retrieving user's GAR divs", "is-danger");
        });
    },

    dbUpdateSequenceSharedWithGro(gro) {
      if (gro.shared == true) {
        GarGroDataService.addSequence(this.$props.id, gro.id)
          .then((response) => {
            console.log("addSequence", response.data);
            this.showToast(this.$t("Toast.INFO_UPDATED"), "is-success");
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        GarGroDataService.removeSequence(this.$props.id, gro.id)
          .then((response) => {
            console.log("removeSequence", response.data);
            this.showToast(this.$t("Toast.INFO_UPDATED"), "is-success");
          })
          .catch((e) => {
            console.log(e);
            this.showToast(
              "Error when updating sequence sharing preferences with gro",
              "is-danger"
            );
          });
      }
    },

    checkIfGarGrosShared(grosArray) {
      grosArray.forEach((gro) => {
        //console.log("team", team);
        if (gro.sequences.length > 0) {
          gro.sequences.forEach((sequence) => {
            if (sequence.id == this.$props.id) {
              gro.shared = true;
            }
          });
        } else {
          gro.shared = false;
        }
      });
    },

    dbUpdateSequenceSharedWithDiv(div) {
      if (div.shared == true) {
        GarDivDataService.addSequence(this.$props.id, div.id)
          .then((response) => {
            console.log("addSequence", response.data);
            this.showToast(this.$t("Toast.INFO_UPDATED"), "is-success");
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        GarDivDataService.removeSequence(this.$props.id, div.id)
          .then((response) => {
            console.log("removeSequence", response.data);
            this.showToast(this.$t("Toast.INFO_UPDATED"), "is-success");
          })
          .catch((e) => {
            console.log(e);
            this.showToast(
              "Error when updating sequence shairing preferences with div",
              "is-danger"
            );
          });
      }
    },

    checkIfGarDivsShared(divsArray) {
      divsArray.forEach((div) => {
        //console.log("team", team);
        if (div.sequences.length > 0) {
          div.sequences.forEach((sequence) => {
            if (sequence.id == this.$props.id) {
              div.shared = true;
            }
          });
        } else {
          div.shared = false;
        }
      });
    },

    convertStringFormat(inputString) {
      // Split the input string by "##" to get the individual words
      const words = inputString.split("##");

      // Extract the two words
      const word1 = words[0]; //code DIV GAR
      const word2 = words[1]; //libellé

      // Construct the desired output string
      const outputString = `${word2} (${word1})`;

      return outputString;
    },
  },
};
</script>
